import { router } from "@inertiajs/react";
import { Alert, Button, Stack } from "@mui/material";
import { FormEvent, useState } from "react";

import useFetch, { Body, SuccessHandler } from "../../hooks/useFetch";
import Input, { ChangeHandler, InputType } from "../forms/Input";

interface Values {
  starts_at: string;
  published: boolean;
}

const EventForm = ({
  initialValues,
  method,
  url,
}: {
  initialValues: Values;
  method: string;
  url: string;
}) => {
  const [values, setValues] = useState(initialValues);
  const [errors, setErrors] = useState<Record<string, string[]>>({});
  const handleSuccess: SuccessHandler = ({ json }) =>
    router.visit(`/admin/events/${json.id}`);
  const [post, { error, loading }] = useFetch(url, {
    method,
    onSuccess: handleSuccess,
  });

  const handleChange: ChangeHandler = (e) => {
    const { name, value } = e.target;
    setValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
    if (name !== "price") {
      setErrors({});
    }
  };
  const handleSubmit = (e: FormEvent) => {
    e?.preventDefault();
    post({
      event: values as unknown as Body,
    });
  };

  return (
    <form onSubmit={handleSubmit}>
      <Stack spacing={1}>
        <Input
          error={errors.starts_at?.[0]}
          label="Datum"
          name="starts_at"
          type={InputType.DateTime}
          value={values.starts_at}
          onChange={handleChange}
        />
        <Input
          error={errors.published?.[0]}
          label="Gepubliceerd"
          name="published"
          type={InputType.Checkbox}
          value={values.published}
          onChange={handleChange}
        />
      </Stack>
      {error && (
        <Alert severity="error" sx={{ marginTop: "1em" }}>
          {error}
        </Alert>
      )}
      <Stack direction="row" justifyContent="end">
        <Button
          loading={loading}
          sx={{ marginTop: "1em" }}
          type="submit"
          variant="contained"
        >
          Verstuur
        </Button>
      </Stack>
    </form>
  );
};

export default EventForm;
